export default __webpack_public_path__ + "static/AeonikRegular-c33f50bae2d3707babff0c34c650b059.eot";